import { gql } from '@apollo/client';
import TENANT_MANUFACTURER from 'api/fragments/TENANT_MANUFACTURER';
const GET_CURRENT_TENANT_MANUFACTURERS = gql `
  ${TENANT_MANUFACTURER}
  query GetCurrentTenantManufacturers(
    $first: Int
    $after: String
    $isPublic: Boolean
    $name: String
    $statusId: String
  ) {
    me {
      id
      currentTenant {
        id
        manufacturers(
          first: $first
          after: $after
          isPublic: $isPublic
          name: $name
          status: $statusId
        ) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              ...TenantManufacturerFragment
            }
          }
        }
      }
    }
  }
`;
export default GET_CURRENT_TENANT_MANUFACTURERS;
